import React, { FC, useEffect, useRef, useState } from 'react';
import { navigate } from 'gatsby';
import ConfigContext, { GetPagePath, Route } from './config-context';

const { Provider } = ConfigContext;

const getMatchingPath = (initialRoutes: Route) => (path: string) => {
  function findMatchingPath(routes: Route[] = [], builtPath = '') {
    const matchIndex = routes.findIndex(({ path: routePath }) => path === routePath);
    if (matchIndex !== -1) return `${builtPath}/${routes[matchIndex].path}`;
    for (let i = 0; i < routes.length; i += 1) {
      if (routes[i].routes) {
        return findMatchingPath(routes[i].routes, `${builtPath}/${routes[i].path}`);
      }
    }
    return '';
  }
  return findMatchingPath(initialRoutes.routes, `/${initialRoutes.path}`);
};

interface ConfigProviderProps {
  pageContext: GatsbyTypes.SitePageContext;
}

const ConfigProvider: FC<ConfigProviderProps> = ({ pageContext, children }) => {
  const pageRef = useRef<string>();
  const { name: page, configJson } = pageContext;
  const [getPagePath, setGetPagePath] = useState<GetPagePath>(() => () => '');
  const [paymentMode, setPaymentMode] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('setPaymentMode', () => {
      setPaymentMode(true);
    });

    return () => window.removeEventListener('setPaymentMode', () => false);
  });

  const is404 = page === '/404.html';

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  const previousPage = pageRef.current;

  useEffect(() => {
    if (is404) {
      navigate('/');
    }
  }, [is404]);

  return !is404 ? (
    <Provider
      value={{
        page,
        previousPage,
        getPagePath,
        setGetPagePath,
        getMatchingPath,
        ...configJson,
        paymentMode: configJson?.paymentMode || paymentMode,
      }}
    >
      {children}
    </Provider>
  ) : null;
};

export default ConfigProvider;
